export const DISCIPLINE_CHIP_COLORS = [
    { backgroundColor: '#e8f2ff', color: '#0b66d8' },
    { backgroundColor: '#e7f7ef', color: '#047857' },
    { backgroundColor: '#fff4de', color: '#b45309' },
    { backgroundColor: '#f3e8ff', color: '#7e22ce' },
    { backgroundColor: '#ffe8ee', color: '#be123c' },
    { backgroundColor: '#e7f7fb', color: '#0e7490' },
    { backgroundColor: '#eef2ff', color: '#4338ca' },
    { backgroundColor: '#f0fdf4', color: '#15803d' }
];

export const getDisciplineChipColors = (label) => {
    const value = String(label || '');
    const hash = value.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return DISCIPLINE_CHIP_COLORS[hash % DISCIPLINE_CHIP_COLORS.length];
};

export const getDisciplineChipSx = (label) => {
    const colors = getDisciplineChipColors(label);

    return {
        height: 28,
        borderRadius: 2,
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        fontWeight: 800,
        fontSize: '0.82rem',
        '& .MuiChip-label': { px: 1.4 }
    };
};

export const competitionTypeChipSx = {
    height: 28,
    borderRadius: 2,
    backgroundColor: '#d9d2f3',
    color: '#4c3a8d',
    fontWeight: 800,
    fontSize: '0.82rem',
    '& .MuiChip-label': { px: 1.4 }
};

export const STRIKETHROUGH_COMPETITION_STATUS_IDS = new Set([1130, 1190]);

export const COMPETITION_STATUS_CHIPS = {
    1130: {
        label: 'Σε αναστολή',
        sx: {
            backgroundColor: '#fdba74',
            color: '#ffffff',
            border: '1px solid #fdba74'
        }
    },
    1190: {
        label: 'Ακυρώθηκε',
        sx: {
            backgroundColor: '#b91c1c',
            color: '#ffffff',
            border: '1px solid #fca5a5'
        }
    }
};

export const getCompetitionStatusId = (item) =>
    Number(
        item?.StatusId ??
            item?.statusId ??
            item?.CompetitionStatusId ??
            item?.competitionStatusId ??
            item?.competitionStatus?.id ??
            item?.CompetitionStatus?.Id
    );

export const shouldStrikeThroughCompetition = (item) => STRIKETHROUGH_COMPETITION_STATUS_IDS.has(getCompetitionStatusId(item));

export const getCompetitionStatusChip = (item) => COMPETITION_STATUS_CHIPS[getCompetitionStatusId(item)] ?? null;
